/**
 * Servicio que se encarga del manejo de las peticiones sobre las 
 * acciones "Crear, Modificar y Eliminar" los tipos de servicio de PQR.
 * JMM-2018-07-11
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service'; 

@Injectable()
export class TiposervicioService {

  public tiposervicios : any[] = [];
  PATH = new ConfigService().obtenerPath();

  constructor(
    private http  : Http,
    private _key  : KeyService
  ) {}

  /**
   * Obtener listado de tipos de servicio
   * JMM-2018-07-11
   */
  getTipoServicio()
  {
    let url = this.PATH + '/api/admin/tiposerviciopqr';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getTipoServicio()

  /**
   * Obtener un registro por id de un tipo de servicio para editar
   * JMM-2018-07-11
   */
  getRegTipoServicio(id:any)
  {
    let url = this.PATH + '/api/admin/tiposerviciopqr/'+id+'/edit';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegTipoServicio()

  /**
   * Enviar registros de tipo de servicio para guardar
   * JMM-2018-07-11
   */
  setTipoServicio(tiposervicio:any)
  {
    let url = this.PATH + '/api/admin/tiposerviciopqr';
    return this.http.post(url, tiposervicio, {headers:this._key.head()}).map(resp => resp.json());
  }// .setTipoServicio(tiposervicio:any)

  /**
   * Editar Tipo de servicio
   * JMM-2018-07-11
   */
  editTipoServicio(tiposervicio:any)
  {
    let url = this.PATH+'/api/admin/tiposerviciopqr/'+tiposervicio.id; 
    return this.http.put(url, tiposervicio, {headers:this._key.head()}).map( resp => resp.json()); 
  }// .editTipoServicio(tiposervicio:any)

  /**
   * Eliminar tipo de servicio
   * JMM-2018-07-11
   */
  destroyTipoServicio(id:any)
  {
    let url = this.PATH + '/api/admin/tiposerviciopqr/'+id;
    return this.http.delete(url, {headers:this._key.head()}).map( resp => resp.json());        
  }// .destroyTipoServicio(id:any)

  obtenerFiltro(info)
  {
    let id = info.id != '' ? info.id : null;
    let nombre = info.nombre  != '' ? info.nombre    : null;

    let url = this.PATH + '/api/admin/obtenerfiltrotiposervicio/'+id+'/'+nombre;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Permite obtener el servicio de mantenimiento preventivo
   * JMM-2019-01-14 
   */
  obtener_serviciopreventivo()
  {
    let url = this.PATH + '/api/admin/obtener_servicio_preventivo';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .obtener_serviciopreventivo()

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/pqr/tiposervicio.service.ts